function Career() {
  return (
    <div id="career-container" className="flex justify-center content-center lg:px-32 md:px-16 px-8 md:mt-32 mt-16">
      <div className="career flex flex-col min-w-full">
            <p className="font-bold lg:text-5xl md:text-3xl text-2xl">
                Career
            </p>
        <center>
            <div className="career-grid grid lg:grid-cols-3 grid-cols-1 font-light mt-6 gap-x-4 w-max text-left">
                <div class="container flex justify-center w-max">
                    <div class="max-w-sm md:py-8 py-2">
                        <div class="py-3 px-3 lg:text-2xl md:text-xl text-base">
                            <h1 class="text-gray-200 font-bold md:text-3xl sm:text-2xl text-xl mb-3 border-l border-blue-400 leading-4 pl-4">GetAccess</h1>
                            <h1 class="text-gray-200 md:text-2xl text-xl mb-3 pl-4">Full Stack Intern</h1>
                            <p class="text-gray-400 md:text-xl text-base tracking-wide pl-4 -mt-1">Jan 2021 – Feb 2021</p>
                        </div>
                    </div>
                </div>

                <div class="container flex justify-center w-max">
                    <div class="max-w-sm md:py-8 py-2">
                        <div class="py-3 px-3 lg:text-2xl md:text-xl text-base">
                            <h1 class="text-gray-200 font-bold md:text-3xl sm:text-2xl text-xl mb-3 border-l border-blue-400 leading-4 pl-4">Logward</h1>
                            <h1 class="text-gray-200 md:text-2xl text-xl mb-3 pl-4">Software Dev. Intern</h1>
                            <p class="text-gray-400 md:text-xl text-base tracking-wide pl-4 -mt-1">May 2021 – July 2021</p>
                        </div>
                    </div>
                </div>

                <div class="container flex justify-center w-max">
                    <div class="max-w-sm md:py-8 py-2">  
                        <div class="py-3 px-3 lg:text-2xl md:text-xl text-base">
                            <h1 class="text-gray-200 font-bold md:text-3xl sm:text-2xl text-xl mb-3 border-l border-blue-400 leading-4 pl-4">Sprinklr</h1>
                            <h1 class="text-gray-200 md:text-2xl text-xl mb-3 pl-4">Product Engineering Intern</h1>
                            <p class="text-gray-400 md:text-xl text-base tracking-wide pl-4 -mt-1">May 2022 – July 2022</p>
                        </div>
                    </div>
                </div>
            </div>
        </center>
      </div>
    </div>
  );
}

export default Career;
